import classnames from 'classnames';

import {ChevronLightRegularDown} from 'shells/icon/svg/chevron-light-regular-down-icon';
import {ExternalArrowRegularIcon} from 'shells/icon/svg/external-arrow-regular-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';

import styles from './widget-see-all-footer.module.css';

// Changing this to temporarily for our sales team that always
// want to see this link, as they use it frequently, even for 1 item.
const MIN_ITEMS_FOR_LIST_LINK = 1;

type SeeAllProps = {
    isExpanded: boolean;
    hasMore: boolean;
    term: string;
    onClick: () => void;
};

interface Props {
    seeAllProps?: SeeAllProps;
    listLink?: string;
    listLinkItemCount?: number;
}

export function WidgetSeeAllFooter(props: Props) {
    const showSeeAll = Boolean(props.seeAllProps?.hasMore && !props.seeAllProps?.isExpanded);
    const showListLink = Boolean(
        props.listLink && (props.listLinkItemCount ?? 0) >= MIN_ITEMS_FOR_LIST_LINK
    );
    const showFooter = showSeeAll || showListLink;

    if (!showFooter) {
        return null;
    }

    return (
        <div
            className={classnames(styles.footer, {
                [styles['footer-with-list-border']]: showFooter,
            })}
        >
            {showSeeAll && (
                <Link
                    as='button'
                    variant='secondary-light'
                    size='small'
                    onClick={props.seeAllProps?.onClick}
                >
                    <Stack isHorizontal={true} spacing={6} alignItems='center'>
                        See all {props.seeAllProps?.term}
                        <ChevronLightRegularDown size={12} wrapWithDiv={false} />
                    </Stack>
                </Link>
            )}
            {showListLink && props.listLink && (
                <Link newTab={true} variant='secondary-light' size='small' href={props.listLink}>
                    <Stack isHorizontal={true} spacing={6} alignItems='center'>
                        View in list
                        <ExternalArrowRegularIcon size={12} wrapWithDiv={false} />
                    </Stack>
                </Link>
            )}
        </div>
    );
}
